module.exports = __webpack_public_path__ + "media/images/indicator-arrow-0ae3fccdaab95aaf362ebd6a34f74402.png";